import produce from "immer";
import {
  FETCH_HOMES,
  FETCH_HOMES_SUCCESS,
  FETCH_HOMES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_HOME,
  ADD_HOME_SUCCESS,
  ADD_HOME_FAILURE,
  //
  EDIT_HOME,
  EDIT_HOME_SUCCESS,
  EDIT_HOME_FAILURE,
  //
  DELETE_HOME,
  DELETE_HOME_SUCCESS,
  DELETE_HOME_FAILURE,
  //
  SEARCH_HOME,
  SEARCH_HOME_SUCCESS,
  SEARCH_HOME_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingHomes: false,
  Homes: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentHome: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  searchHomeList: [],
};

const HomesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_HOMES:
        draft.isFetchingHomes = true;
        draft.currentHome = {};
        break;
      case FETCH_HOMES_SUCCESS:
        draft.isFetchingHomes = false;
        draft.Homes = action.payload;
        break;
      case FETCH_HOMES_FAILURE:
        draft.isFetchingHomes = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentHome = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentHome = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_HOME:
        draft.isSubmitting = true;
        break;
      case ADD_HOME_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_HOME_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_HOME:
        draft.isSubmitting = true;
        break;
      case EDIT_HOME_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_HOME_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_HOME:
        draft.isDeleting = true;
        break;
      case DELETE_HOME_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_HOME_FAILURE:
        draft.isDeleting = false;
        break;
      //search
      case SEARCH_HOME:
        draft.isSearching = true;
        draft.searchHomeList = [];
        break;
      case SEARCH_HOME_SUCCESS:
        draft.isSearching = false;
        draft.searchHomeList = action.payload;
        break;
      case SEARCH_HOME_FAILURE:
        draft.isSearching = false;
        draft.searchHomeList = [];
        break;
      default:
        return state;
    }
  });

export default HomesReducer;
